<template>
    <div>
        <div class="flex justify-between items-center mb-6">
            <div v-if="isEdit" class="flex cursor-pointer text-green-600 hover:text-green-700" @click="goBack">
                <i class='bx bx-left-arrow-alt bx-sm my-auto'></i>
                <p class="text-xl font-semibold d-none d-md-block">Chỉnh sửa trang tuyển dụng</p>
                <p class="text-xl font-semibold d-block d-md-none">Quay lại</p>
            </div>
            <p v-else class="text-xl font-semibold">Quản lý tuyển dụng</p>
            <div>
                <div class="flex gap-1" v-if="isEdit">
                    <button @click="getEntry" class="admin-refresh-btn">
                        <i class='bx bx-refresh my-auto' ></i><p>Đặt lại</p>
                    </button>
                    <button @click="saveEntry" class="admin-save-btn">
                        <i class='bx bxs-save my-auto' ></i><p>Lưu</p>
                    </button>
                </div>
                <button @click="isEdit = true" v-else class="admin-edit-btn">
                    <i class='bx bxs-edit-alt text-black my-auto' ></i><p>Chỉnh sửa</p>
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <div class="p-1 flex gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle:recruitment-1>
                    <h3 class="text-lg font-semibold text-left mb-0">Nguyên tắc tuyển dụng</h3>
                </div>
                <b-collapse visible class="px-3 py-2" id="recruitment-1" accordion="my-accordion">
                    <b-form-group>
                        <label class="mb-1 text-lg d-flex align-items-center">
                            Mô tả
                        </label>
                        <b-textarea :disabled="!isEdit" rows="7" v-model="entry.generalStandard" type="text" placeholder="Nhập lời mở đầu..." />
                    </b-form-group>
                </b-collapse>
            </div>
            <div class="col-12 mb-3">
                <div class="p-1 flex gap-2 px-3 py-1 bg-slate-600 text-white rounded-xl cursor-pointer" role="tab" v-b-toggle:recruitment-2>
                    <h3 class="text-lg font-semibold text-left mb-0">Tiêu chuẩn chung</h3>
                </div>
                <b-collapse class="px-3 py-2" id="recruitment-2" accordion="my-accordion">
                    <b-form-group>
                        <label class="mb-1 text-lg d-flex align-items-center">
                            Mô tả
                        </label>
                        <b-textarea :disabled="!isEdit" rows="7" v-model="entry.recruitmentPrinciples" type="text" placeholder="Nhập lời mở đầu..." />
                    </b-form-group>
                </b-collapse>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'manage-recruitment',
    data() {
        return {
            webConfig: {},
            entry: {},
            isEdit: false,
            isSave: false,
        }
    },
    methods: {
        ...mapActions('webConfig', ['GetWebConfigList', 'UpdateWebConfig']),
        async getEntry() {
            let response = await this.GetWebConfigList()
            this.webConfig = response.data
            this.entry = this.webConfig.manageRecruitment
        },
        goBack() {
            this.getEntry()
            this.isEdit = false
        },
        saveEntry() {
            let validate = {
                generalStandard: 'Nguyên tắc tuyển dụng',
                recruitmentPrinciples: 'Nguyên tắc tuyển dụng',
            };
            if (!this.$validator(this.entry, validate)) return
            this.$swal.fire({
            title: 'Sửa cấu hình trang web?',
            text: "",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sửa!',
            cancelButtonText: 'Hủy'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let response = await this.UpdateWebConfig(this.webConfig)
                    if (response.code == 200) {
                        this.getEntry()
                        this.isEdit = false
                        this.$swal.fire('Cập nhật thành công', '', 'success')
                    } else {
                        this.$swal.fire('Cập nhật không thành công', '', 'error')
                    }
                }
            })
        }
    },
    created(){
        this.getEntry()
    },
}
</script>